import React, { useCallback, useState, useRef } from 'react'
import PropTypes from 'prop-types'

import '@aytm/lib/rfd-ui/styles/basic/pagination.scss'

Pagination.propTypes = {
  page: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  prefix: PropTypes.string,
  separator: PropTypes.string,
  disabled: PropTypes.bool,
  onPageChange: PropTypes.func.isRequired
}
export default function Pagination({ page, total, prefix = '', separator = ' of ', disabled, onPageChange } = {}) {
  const onPrev = useCallback(() => {
    if (onPageChange) {
      onPageChange(page - 1)
    }
  }, [page, onPageChange])

  const onNext = useCallback(() => {
    if (onPageChange) {
      onPageChange(page + 1)
    }
  }, [page, onPageChange])

  const counterElementRef = useRef(null)
  const manualInputElementRef = useRef(null)
  const [manualInput, setManualInput] = useState(false)
  const [manualInputWidth, setManualInputWidth] = useState(null)
  const enableManualInput = useCallback(() => {
    if (counterElementRef.current) {
      const counterElementWidth = counterElementRef.current.getBoundingClientRect().width
      if (counterElementWidth !== manualInputWidth) {
        setManualInputWidth(counterElementWidth)
      }
    }
    setManualInput(true)
  }, [manualInputWidth])
  const onManualInputBlur = useCallback(() => {
    if (manualInputElementRef.current) {
      const manualInputValue = Math.min(total, Math.max(1, parseInt(manualInputElementRef.current.value, 10) || 0))
      if (page !== manualInputValue && onPageChange) {
        onPageChange(manualInputValue)
      }
      setManualInput(false)
    }
  }, [page, total, onPageChange])
  const onManualInputKeyPress = useCallback(
    event => {
      if ('Enter' === event.key) {
        onManualInputBlur()
      }
    },
    [onManualInputBlur]
  )

  const prevDisabled = disabled || 1 >= page
  const nextDisabled = disabled || total <= page

  return (
    <div className={`rfd-ui-pagination${disabled ? ' rfd-ui-pagination-disabled' : ''}`}>
      <span
        className={`rfd-ui-pagination-prev${prevDisabled ? ' rfd-ui-pagination-disabled' : ''}`}
        onClick={prevDisabled ? null : onPrev}
      />
      {manualInput ? (
        <input
          type="number"
          className="rfd-ui-pagination-manual-input"
          autoFocus={true}
          defaultValue={page}
          min="1"
          max={total}
          placeholder={`?${separator}${total}`}
          title={`?${separator}${total}`}
          style={{ width: manualInputWidth }}
          onKeyPress={onManualInputKeyPress}
          onBlur={onManualInputBlur}
          ref={manualInputElementRef}
        />
      ) : (
        <span
          className="rfd-ui-pagination-counter"
          ref={counterElementRef}
          onClick={disabled ? null : enableManualInput}
        >{` ${prefix}${page}${separator}${total} `}</span>
      )}
      <span
        className={`rfd-ui-pagination-next${nextDisabled ? ' rfd-ui-pagination-disabled' : ''}`}
        onClick={nextDisabled ? null : onNext}
      />
    </div>
  )
}
